import React from 'react'
import Svg, { Circle, Text as SvgText } from 'react-native-svg'

type Avatar0Colors = {
  background?: string;
  txt?: string;
  //skin?: string;
  //hair?: string;
  //accessories?: string;
};

export const Avatar0 = ({
  colors = {},
  size = 96,
  name,
}: {
  colors?: Avatar0Colors;
  size?: number | string;
  name?: string;
}) => {

  const c = {
    background: colors.background ?? "#fff",
    txt: colors.txt ?? '#fff'
    //skin: colors.skin ?? "#fff",
    //hair: colors.hair ?? "#fff",
    //accessories: colors.accessories ?? "#fff",
  };

  const userInitial = name?.trim()?.[0]?.toUpperCase() ?? '?'

  return (
    <Svg width={size} height={size} viewBox="0 0 48 48">
      <Circle id="background" cx={24} cy={24} r={24} fill={c.background} />
      <SvgText x={24} y={24} textAnchor="middle" alignmentBaseline="central" fontSize={24} fill={c.txt}>
        {userInitial}
      </SvgText>
    </Svg>
  )
}
